// @ts-ignore
import type { ToasterProps } from '@nuxt/ui'
import type { ScrollTopProps } from '../types'
import type { APIResolverOptions } from './composables/api'

interface AppProps {
	toaster?: ToasterProps,
	scrollTop: ScrollTopProps,
	colorModePreference?: 'light' | 'dark' | 'system'
}


declare module '@nuxt/schema' {
	interface AppConfigInput {
		gsmaterials?: {
			/** Project name */
			app?: AppProps
			apiData: {[id: string]: APIResolverOptions}
		}
	}
}

export default {
	gsmaterials: {
		app: {
			toaster: {
				position: 'bottom-right',
				expand: false
			},
			scrollTop: {
				offset: 250,
				size: 'sm',
				icon: 'i-mdi-chevron-up'
			},
			colorModePreference: 'system'
		}
	},
	ui: {
		colors: {
			primary: "primary",
			secondary: "secondary",
			accent: "accent",
			info: 'cyan',
			warning: 'orange'
		},
		toast: {
			slots: {
				root: 'shadow-24 shadow-gray-500 dark:shadow-gray-800',
				title: 'font-bold text-md',
				description: 'font-thinner'
			},
			variants: {
				color: {
					primary: {
						root: 'bg-primary-200/95 focus-visible:ring-primary-900',
						icon: 'text-primary-800',
						progress: 'bg-primary-700',
						title: 'text-primary-800 flex-inline items-center',
						description: 'text-primary-700',
						close: 'text-primary-800'
					},
					secondary: {
						root: 'bg-secondary-200/95 focus-visible:ring-secondary-900',
						icon: 'text-secondary-800',
						progress: 'bg-secondary-700',
						title: 'text-secondary-800 flex-inline items-center',
						description: 'text-secondary-700',
						close: 'text-secondary-800'
					},
					accent: {
						root: 'bg-accent-200/95 focus-visible:ring-accent-900',
						icon: 'text-accent-800',
						progress: 'bg-accent-700',
						title: 'text-accent-800 flex-inline items-center',
						description: 'text-accent-700',
						close: 'text-accent-800'
					},
					success: {
						root: 'bg-success-200/95 focus-visible:ring-success-900',
						icon: 'text-success-800',
						progress: 'bg-success-700',
						title: 'text-success-800',
						description: 'text-success-700',
						close: 'text-success-800'
					},
					info: {
						root: 'bg-info-200/95 focus-visible:ring-info-900',
						icon: 'text-info-800',
						progress: 'bg-info-700',
						title: 'text-info-800 flex-inline items-center',
						description: 'text-info-700',
						close: 'text-info-800'
					},
					warning: {
						root: 'bg-warning-200/95 focus-visible:ring-warning-900',
						icon: 'text-warning-800',
						progress: 'bg-warning-700',
						title: 'text-warning-800 flex-inline items-center',
						description: 'text-warning-700',
						close: 'text-warning-800'
					},
					error: {
						root: 'bg-error-200/95 focus-visible:ring-error-900',
						icon: 'text-error-800',
						progress: 'bg-error-700',
						title: 'text-error-800 flex-inline items-center',
						description: 'text-error-700',
						close: 'text-error-800'
					},
					neutral: {
						root: 'bg-inverted/95 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-inverted',
						'title': 'text-inverted',
						icon: 'text-inverted',
						description: 'text-inverted/80',
						progress: 'bg-white dark:bg-gray-950',
						close: 'text-inverted'
					}
				},
				defaultVariants: {
					color: 'neutral'
				}
			}
		}
	}
}
